<template>
    <div class="bgff">
        <img src="../assets/img/userbg.png" class="w100 sdfsdtyte">
        <div class="pd pt80 pr">
            <div class=" bgff sdfsdytywe">
                <p class="cen">
                    <img :src="member.headImgUrl" class="yj usericowertr">
                </p>
                <p class="fz20 z3 cen" v-if="member.mobile">
                   {{member.mobile.substr(0,3)+"****"+member.mobile.substr(7)}}
                </p>
                <p class="fz16 z9 cen mt10" v-if="member.name">
                    {{member.name}}
                </p>
                <p class="fz16 z9 cen mt10" v-if="member.customerName">
                    {{member.customerName}}
                </p>
            </div>
            <div class="ov pt30 bgff sdfsdtte">
                <van-grid :column-num="3" :border="false" >
                    <van-grid-item v-if="groupOrderFlag && member.hasRegistCustomer" @click="showCustomer">
                        <p class="cen mt10">
                            <i class="f_i jmmmnxeer aj" ></i>
                        </p>
                        <p class="fz14 z6 mt10 cen mb10">团队信息</p>
                    </van-grid-item>
                    <van-grid-item v-if="groupOrderFlag && !member.isCustomerLogin"  @click="toGrouplogin" >
                        <p class="cen mt10">
                            <i class="f_i jmmmnxeer ai" ></i>
                        </p>
                        <p class="fz14 z6 mt10 cen mb10">团队登录</p>
                    </van-grid-item>               
                    <!-- <van-grid-item  @click="onMemberCardClick">
                        <p class="cen mt10">
                            <i class="f_i jmmmnxeer" ></i>
                        </p>
                        <p class="fz14 z6 mt10 cen mb10">电子会员码</p>
                    </van-grid-item> -->
                    
                    <van-grid-item v-for="menuItem in member.menuItems" :key="menuItem.name" :to="menuItem.url">
                        <p class="cen mt10">
                            <i class="f_i jmmmnxeer" :class="menuItem.icon"></i>
                        </p>
                        <p class="fz14 z6 mt10 cen mb10">{{menuItem.displayName}}</p>
                    </van-grid-item>
                    <van-grid-item v-if="groupOrderFlag && member.isCustomerLogin" to="/changepassword/0/''/''/''">
                        <div class="cen mt10">
                            <img src="../assets/img/resetPassword.png" class="signOut"/>
                        </div>
                        <p class="fz14 z6 mt10 cen mb10">修改密码</p>
                    </van-grid-item>
                    
                    <van-grid-item v-if="groupOrderFlag && member.isCustomerLogin" @click="logout">
                        <div class="cen mt10">
                            <img src="../assets/img/signOut.png" class="signOut"/>
                        </div>
                        <p class="fz14 z6 mt10 cen mb10">团队退出</p>
                    </van-grid-item>
                </van-grid>
            </div>
        </div>
    </div>
</template>

<script>
// import { createNamespacedHelpers } from "vuex";
// const { mapState } = createNamespacedHelpers("memberModule");
import memberService from "@/services/memberService.js";
import settingService from "./../services/settingService.js";


import { mapState, mapActions } from "vuex";
import appConsts from "@/store/consts.js";

export default {
  data() {
    return {        
      groupOrderFlag :false
    };
  },
  computed: {
    ...mapState({
      member: (state) => state.memberModule.member,
    }),
    // ...mapState(["member"])
  },
  async created() {      
    await this.loadMemberAsync();
    const options = await settingService.getOptionsAsync();
      if (options && options.GroupOrderFlag && options.GroupOrderFlag=="1") {
        this.groupOrderFlag=true;
      }
      //console.log(JSON.stringify(this.member));
  },
  methods: {
    async logout() {
      try {
        await this.$dialog.confirm({ title: "确定退出？" });

        await memberService.customerLogoutAsync();
      } catch (err) {
        console.log(err);
      }
    },
    onMemberCardClick() {
      if (this.member.hasElectronicMemberCard) {
        this.$router.push("/membercard");
      } else {
        //this.$router.push("/registmembercard");
        this.$toast("此功能暂未开放");
      }
    },
    toGrouplogin(){
        this.$router.push("/grouplogin/0/my/0");
    },
    showCustomer() {
      this.$router.push({
        name: "groupregist",
        query: { customerId: this.member.customerId }
      });
    },
    
    ...mapActions("memberModule", [appConsts.loadMemberAsync]),
  }
};
</script>

<style lang="scss" scoped>

    .sdfsdtyte {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 1;
        height: 140px;
    }
    .usericowertr {
        width: 63px;
        height: 63px;
        margin-top: -31px;
    }
    .jmmmnxeer {
        width: 33px;
        height: 29px;
        background-position: -67px -275px;
    }
    .jmmmnxeer.completed {
        width: 29px;
        background-position: -112px -277px;
    }
    .jmmmnxeer.enroll_order {
        background-position: -67px -375px;
    }
    .jmmmnxeer.orderCode {
        width: 29px;
        background-position: -157px -275px;
    }
    .signOut {
        height: 29px;
        width: 29px;
    }
    .jmmmnxeer.jiangjie {
        width: 39px;
        background-position: -205px -273px;
    }
    .jmmmnxeer.jiangjiechaxun {
        height: 32px;
        background-position: -110px -373px;
    }
    .jmmmnxeer.yanpiao {
        width: 33px;
        background-position: -259px -275px;
    }
    .jmmmnxeer.zhtongji {
        width: 26px;
        background-position: -229px -188px;
    }
    .jmmmnxeer.yktongji {
        width: 35px;
        background-position: -221px -137px;
    }
    .jmmmnxeer.klltongji {
        width: 33px;
        background-position: -286px -134px;
    }
    .jmmmnxeer.ai {
        width: 34px;
        height: 32px;
        background-position: -11px -273px;
    }
    .jmmmnxeer.ac {
        width: 29px;
        background-position: -157px -275px;
    }
    .jmmmnxeer.aj {
        width: 28px;
        background-position: -11px -375px;
    }
    .sdfsdytywe {
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
        position: relative;
        z-index: 100;
        border-radius: 10px;
        padding-bottom: 30px;
    }

    .sdfsdtte {
        margin-top: -10px;
    }

</style>